import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { StoreContext } from "../context";
// import logo from "../assets/condorNav-03.svg";
import logo from "../assets/bank-assets/nav-logo.svg";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Stack, TextField } from "@mui/material";
import { Toast } from "primereact/toast";
import { Message } from "primereact/message";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ReactFlagsSelect from "react-flags-select";
import { useTranslation } from "react-i18next";
import { BASE_URL_DASHBOARD, Simulator } from "../constant";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import { useRecoilState } from "recoil";
import Lottie from "react-lottie";
import animationData from "../assets/lottie/95088-success.json";
import { Tooltip } from "primereact/tooltip";
import {
  age,
  borrowedCapital,
  CAAT,
  DurationCredit,
  hamishEldjedia,
  Salary,
  SNMG,
  TALA,
  TauxBEA,
  TMM,
  PremiumClient,
  modalState,
} from "../states/atoms/simulator";
import CartButton from "./CartButton";
// import { Tooltip } from 'primereact/tooltip';
import infoIcon from "../assets/icons/info.png";

import FavoriList from "./FavoriList";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";

import { favoriList } from "../states/atoms/products";

import FavoritesButton from "../components/FavoritesButton";

import { useDeviceSize } from "react-device-sizes";

import SimulatorComp from "../components/Simulator";

function Navbar() {
  const {
    xsDown, //(max-width: 575.98px)
    onlyXs, //(min-width: 576px) and (max-width: 767.98px)
    xsUp, //(min-width: 576px)
    smDown, //(max-width: 767.98px)
    onlySm, //(min-width: 768px) and (max-width: 991.98px)
    smUp, //(min-width: 768px)
    mdDown, //(max-width: 991.98px)
    onlyMd, //(min-width: 992px) and (max-width: 1199.98px)
    mdUp, //(min-width: 992px)
    lgDown, //(max-width: 1199.98px)
    lgUp, //(min-width: 1200px)
  } = useDeviceSize();

  const [visibleRight, setVisibleRight] = useState(false);
  // const [favori] = useRecoilState(favoriList);
  const [favorie, setFavorie] = useRecoilState(favoriList);
  const favorieCount = favorie.length;

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dateValue, setDateValue] = useState(dayjs("2000-08-18T21:11:54"));
  const handleChange = (newValue) => {
    setDateValue(newValue);
  };
  // eslint-disable-next-line
  const { cart } = useContext(StoreContext);
  const [width, setWidth] = useState(window.innerWidth);
  const [showModal, setShowModal] = useRecoilState(modalState);
  let variables2 = useRef();
  const location = useLocation();

  //todo: Simulator Values
  const toast = useRef(null);
  const [prixState, setPrixState] = useState(0);
  const [_SNMG, setSNMG] = useRecoilState(SNMG);
  const [_TauxBEA, setTauxBEA] = useRecoilState(TauxBEA);
  const [_DurationCredit, setDurationCredit] = useRecoilState(DurationCredit);
  const [isPremiumClient, setISPremiumClient] = useRecoilState(PremiumClient);
  const [_Salary, setSalary] = useRecoilState(Salary);
  const [_age, setAge] = useRecoilState(age);
  const [_borrowedCapital, setBorrowedCapital] =
    useRecoilState(borrowedCapital);
  const [_caat, setCaat] = useRecoilState(CAAT);
  const [_tala, setTala] = useRecoilState(TALA);
  const [_tmm, setTmm] = useRecoilState(TMM);
  const [_hamishEldjedia, setHamishEldjedia] = useRecoilState(hamishEldjedia);

  //todo:simulator state "recoil"

  // eslint-disable-next-line
  const { t, i18n } = useTranslation();

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("i18n", language);
  };

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  useEffect(() => {
    if (width > 768) setMobileMenuOpen(false);
  }, [width]);

  useEffect(() => {
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const amount = cart.reduce((total, obj) => {
    total += obj.amount;
    return total;
  }, 0);

  const price = cart.reduce((price, obj) => {
    price += obj.variantes[obj.colorIndex]?.price * obj.amount;
    return price;
  }, 0);

  const simulatorBackend = () => {
    const amount = cart.reduce((total, obj) => {
      total += obj.amount;
      return total;
    }, 0);

    const price = cart.reduce((price, obj) => {
      price += obj.variantes[obj.colorIndex]?.price * obj.amount;
      return price;
    }, 0);

    console.log("isPremium ====>", isPremiumClient);
    var total = Simulator(18, 30000, price, 36, isPremiumClient);
    variables2.current = total;
    setPrixState(variables2.current.prix);
  };
  //todo: Lottie function
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    simulatorBackend();
  }, []);

  return (
    <>
      <Toast ref={toast} />
      <header>
        <div className="relative flex-col w-full" style={{ height: "5vh" }}>
          <div
            className={`flex z-40 justify-between fixed items-center w-full transition bg-white ${
              mobileMenuOpen ? "" : "shadow-xl"
            } ${
              i18n.language === "fr"
                ? "md:pr-10"
                : "flex-row-reverse md:pr-4 md:pl-10 pr-1"
            }`}
          >
            <Link to="/" className="flex">
              <img className="max-h-10vh xs:max-w-xs" alt="logo" src={logo} />
            </Link>
            <nav className="hidden lg:block">
              <ul
                className={`flex gap-4 lg:gap-6 xl:gap-8 ${
                  i18n.language === "ar" ? "flex-row-reverse" : ""
                }`}
              >
                <li
                  className={`navbar-link ${
                    location.pathname === "/" && !showModal && "active"
                  }`}
                >
                  <NavLink to="/">{t("navbar.home")}</NavLink>
                </li>
                <li
                  className={`navbar-link ${
                    location.pathname === "/products" && !showModal && "active"
                  }`}
                >
                  <NavLink to="/products">{t("navbar.products")}</NavLink>
                </li>
                <li className={`navbar-link ${showModal && "active"}`}>
                  <span
                    className="cursor-pointer disabled:opacity-75"
                    onClick={() => setShowModal(true)}
                  >
                    {t("navbar.simulator")}
                  </span>
                </li>
                <li className="navbar-link">
                  <a href={BASE_URL_DASHBOARD} target="_blank" rel="noreferrer">
                    {t("navbar.vendorspace")}
                  </a>
                </li>
                <li
                  className={`hidden 2xl:block navbar-link ${
                    location.pathname === "/contact" && !showModal && "active"
                  }`}
                >
                  <NavLink to="/contact">{t("navbar.contact")}</NavLink>
                </li>
              </ul>
            </nav>

            <div>
              <div
                className={`hidden lg:flex align-middle gap-8 ${
                  i18n.language === "ar" ? "flex-row-reverse" : ""
                }`}
              >
                <ReactFlagsSelect
                  countries={["FR", "DZ"]}
                  defaultCountry={"FR"}
                  showSelectedLabel={true}
                  placeholder={i18n.language.toUpperCase()}
                  customLabels={{ FR: "FR", DZ: "AR" }}
                  showOptionLabel={true}
                  onSelect={(country) => {
                    if (country === "FR") {
                      changeLanguage("fr");
                    } else {
                      changeLanguage("ar");
                    }
                  }}
                />
                <CartButton
                  isActive={location.pathname === "/cart" && !showModal}
                  items={amount}
                  price={price.toLocaleString("fr-FR")}
                  local={i18n.language}
                />
                <FavoritesButton
                  favorieCount={favorieCount}
                  setVisibleRight={setVisibleRight}
                />
              </div>
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="btn-lg lg:hidden border-0 bg-transparent text-primary-color"
              >
                <i className="fa-lg md:fa-2x fas fa-bars"></i>
              </button>
            </div>
          </div>
        </div>
        {/* ? MOBILE PANEL */}
        <div
          className={`z-20 fixed top-0 left-0 w-full h-screen bg-white px-5 transition-transform duration-500 ease-in-out transform  ${
            mobileMenuOpen ? "" : "-translate-x-full"
          }`}
        >
          <div className="w-full h-full text-primary-color mt-16">
            <ul className="mt-7 flex flex-col gap-7 text-xl text-primary-color text-center">
              <li
                className={`  ${
                  location.pathname === "/" &&
                  !showModal &&
                  "bg-primary-color text-white py-4"
                }`}
              >
                <NavLink to="/"> {t("navbar.home")}</NavLink>
              </li>
              <li
                className={`  ${
                  location.pathname === "/products" &&
                  !showModal &&
                  "bg-primary-color text-white py-4"
                }`}
              >
                <NavLink to="/products"> {t("navbar.products")}</NavLink>
              </li>
              <li>
                <span
                  className="cursor-pointer"
                  onClick={() => setShowModal(true)}
                >
                  {t("navbar.simulator")}
                </span>
              </li>
              <li>
                <a
                  href="https://dashboard.e-faciliti.dz/"
                  rel="noreferrer"
                  target="_blank"
                >
                  {t("navbar.vendorspace")}
                </a>
              </li>
            </ul>

            <div
              className={`mt-10 flex gap-8 justify-center text-primary-color ${
                location.pathname === "/cart" &&
                !showModal &&
                "bg-primary-color text-white py-4"
              }`}
            >
              <CartButton
                items={amount}
                price={price.toFixed()}
                local={i18n.language}
                isActive={location.pathname === "/cart" && !showModal}
                openFromMobileMenu={true}
              />
            </div>

            {/* <div className="mt-10 flex gap-8 justify-center">

                    </div> */}

            <div className="mt-10 flex gap-8 justify-center text-black">
              <FavoritesButton
                favorieCount={favorieCount}
                setVisibleRight={setVisibleRight}
              />
              <ReactFlagsSelect
                countries={["FR", "DZ"]}
                className="bg-white rounded-lg"
                defaultCountry={"FR"}
                showSelectedLabel={true}
                placeholder={i18n.language.toUpperCase()}
                customLabels={{ FR: "FR", DZ: "AR" }}
                showOptionLabel={true}
                onSelect={(country) => {
                  if (country === "FR") {
                    changeLanguage("fr");
                  } else {
                    changeLanguage("ar");
                  }
                }}
              />
            </div>
          </div>
        </div>
        <Sidebar
          visible={visibleRight}
          position={i18n.language === "ar" ? "left" : "right"}
          className="p-sidebar-lg"
          onHide={() => setVisibleRight(false)}
        >
          <h3 className="text-primary-color text-2xl font-bold text-center">
            {t("favori.title")}
          </h3>
          <FavoriList />
        </Sidebar>
      </header>

      <SimulatorComp />
    </>
  );
}

export default Navbar;
